module.exports = __webpack_public_path__ + "static/media/docs-image-02.660b07dc.png";